// extracted by mini-css-extract-plugin
export default {"formItem":"FormItem_formItem__GZm0e"};